export const promotionsURL = '/v1/credit/accounts/manage-promotions/available';
export default promotionsURL;
//# sourceMappingURL=promotions-api.js.map